import { defineStore } from 'pinia';

export const useGlobalStore = defineStore({
    id: 'global',
    state: () => ({
        isPoliticaOpen: JSON.parse(localStorage.getItem("isPoliticaOpen")) || false,
        isCookiesDefined: JSON.parse(localStorage.getItem("isCookiesDefined")) || false
    }),
    actions: {
        triggerPoliticaPrivacidade() {
            this.isPoliticaOpen = !this.isPoliticaOpen;
            console.log(this.isPoliticaOpen);
            localStorage.setItem("isPoliticaOpen", this.isPoliticaOpen);
        },
        triggerCookiesDefined() {
            this.isCookiesDefined = !this.isCookiesDefined;
            localStorage.setItem("isCookiesDefined", this.isCookiesDefined);
        },
    }
});
